import React, { Component } from "react";
import { connect } from "react-redux";
import { HeaderComponent } from "./HeaderComponent";
import {
  getLanguage,
  setCurrentTab,
  toggleSplash
} from "../../../redux/actions/index";

const mapStateToProps = state => {
  return {
    booking: state.booking,
    configuration: state.configuration,
    language: state.language,
    currentTab: state.currentTab,
    previousTab: state.previousTab,
    currentLangCode: state.currentLangCode,
    currentMatspec: state.currentMatspec,
    bookingType: state.bookingType
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getLanguage: langCode => dispatch(getLanguage(langCode)),
    setCurrentTab: tab => dispatch(setCurrentTab(tab)),
    toggleSplash: val => dispatch(toggleSplash(val))
  };
};

class HeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }
  setLanguage = target => {
    const { getLanguage, currentLangCode } = this.props;
    this.setState({ visible: false });
    getLanguage(target.key);
  };
  handleButtonClick = e => {
    this.setState({ visible: !this.state.visible });
  };
  goBack = () => {
    const {
      setCurrentTab,
      currentTab,
      previousTab,
      currentMatspec,
      booking,
      bookingType
    } = this.props;
    if (currentTab === "3" && booking.matspecs.length === 1) return;
    if (
      currentTab === "3" &&
      currentMatspec.printed &&
      bookingType === "DIGITAL_PRINTED"
    ) {
      setCurrentTab("2");
      return;
    }
    if (currentTab === "4") {
      setCurrentTab("3");
      return;
    }
    if (currentTab === "3") {
      setCurrentTab("1");
      return;
    }
    setCurrentTab(previousTab);
  };
  logoClicked = e => {
    const { toggleSplash } = this.props;
    toggleSplash(true);
  };
  helpClicked = e => {
    const { toggleSplash } = this.props;
    toggleSplash(true);
  };
  render() {
    const {
      booking,
      configuration,
      language,
      currentTab,
      previousTab,
      currentLangCode
    } = this.props;
    const { visible } = this.state;
    return (
      <HeaderComponent
        currentLang={currentLangCode}
        currentTab={currentTab}
        goBack={this.goBack}
        handleButtonClick={this.handleButtonClick}
        handleMenuClick={this.setLanguage}
        languages={configuration.languages}
        logoClicked={this.logoClicked}
        helpClicked={this.helpClicked}
        configuration={configuration}
        orderNumber={booking.ad.orderno}
        previousTab={previousTab}
        visible={visible}
        language={language}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/components/Mobile/Header/HeaderContainer.js